import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useIntl } from 'react-intl';

import { isArchive } from '../helpers/App';

const ArchiveHeader = () => {
  const intl = useIntl();
  const location = useLocation();
  const [searchParamsString, setSearchParamsString] = useState('');

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    setSearchParamsString(searchParams.toString());
  }, [location]);

  if (!isArchive()) {
    return null;
  }

  return (
    <div className="archive-header">
      {intl.formatMessage({
        defaultMessage: 'You are browsing the archive',
      })}
      <Link to={`/files?${searchParamsString}`}>
        {intl.formatMessage({
          defaultMessage: 'Return to active files',
        })}
      </Link>
    </div>
  );
};

export default ArchiveHeader;
